import React from 'react';
import usePageTitle from '@/shared/hooks/usePageTitle';
import PolicyPage, { SupportAddress } from './PolicyPage';

/**
 * The accessibility statement: the standard, how it is checked, the known
 * gaps, and how to report a barrier.
 *
 * The known-limitations list is the public half of the conformance report.
 * When the report changes, this list changes with it, and an item leaves
 * the list only when the fix has shipped.
 */
const TITLE = 'Accessibility statement';

function AccessibilityPage() {
    usePageTitle(TITLE);
    return (
        <PolicyPage
            title={TITLE}
            summary={
                <>
                    The exchange is built to meet the Web Content Accessibility
                    Guidelines (WCAG) 2.1 at Level AA, the standard Colorado law
                    (HB21-1110) sets for the partner institutions.
                </>
            }
        >
            <h2>How we check</h2>
            <ul>
                <li>
                    Every page has an automated accessibility check (axe) in the
                    test suite, which runs on every change.
                </li>
                <li>
                    The running site is audited in a browser with axe and
                    Lighthouse, signed out, as a member, and as a coordinator.
                </li>
                <li>
                    Every page is checked by hand for keyboard use, visible
                    focus, zoom to 400%, and text-spacing changes.
                </li>
            </ul>

            <h2>Known limitations</h2>
            <ul>
                <li>
                    Listing photographs carry a generic description (for
                    example, &ldquo;Photo 1 of Office chair&rdquo;). The
                    listing&rsquo;s written description, dimensions, and
                    condition carry the information the photographs show.
                </li>
                <li>
                    Testing with screen readers (VoiceOver, NVDA, and JAWS) is
                    scheduled and not yet complete.
                </li>
            </ul>

            <h2>Report a barrier</h2>
            <p>
                If any part of the exchange is hard to use with your browser,
                device, or assistive technology, write to <SupportAddress />.
                Tell us the page and what happened. We will reply within five
                business days and, while we fix it, help you post or request an
                item another way.
            </p>
            <p>
                A detailed conformance report in the VPAT format is available on
                request from the same address.
            </p>
        </PolicyPage>
    );
}

export default AccessibilityPage;
